import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Storage } from '@ionic/storage-angular';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private storage: Storage | null = null;

  constructor(private injector: Injector) {}

  // Método para garantir que o Storage está pronto antes de recuperar o token
  private async getStorage(): Promise<Storage> {
    if (!this.storage) {
      this.storage = this.injector.get(Storage);
      await this.storage.create();
    }
    return this.storage;
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return from(this.getStorage()).pipe(
      switchMap((storage) => from(storage.get('token'))),
      switchMap((token) => {
        let clonedRequest = req;

        if (token) {
          clonedRequest = req.clone({
            setHeaders: {
              Authorization: `Bearer ${token}`,
            },
          });
        } else {
          console.warn('⚠️ Nenhum token encontrado no Storage!');
        }

        return next.handle(clonedRequest);
      })
    );
  }
}
